import { useMemo } from "react";
import { useSelector } from "react-redux";

/**
 *
 * @returns {{
 *  fullName: string,
 *  userIsLoggedIn: boolean,
 *  apellidos:string,
 *  brokerCodigo:string,
 *  cedula:string,
 *  codigoAgente:string,
 *  correo:string,
 *  tipoUsuario:string
 *  isDTC:boolean,
 *  isAgente:boolean
 *  cliCodigoCore:string
 * }}
 */
const useUsuario = () => {
  const { dataUsuario } = useSelector((state) => state.datosUsuarios);
  const isDTC = useMemo(() => {
    return !dataUsuario?.userIsLoggedIn || dataUsuario?.usu_tipo_usuario === "cliente";
  }, [dataUsuario]);

  const isAgente = useMemo(() => {
    return dataUsuario?.userIsLoggedIn && dataUsuario?.usu_tipo_usuario === "agente-user";
  }, [dataUsuario]);

  return {
    ...dataUsuario,
    fullName: `${dataUsuario?.nombres}  ${dataUsuario?.apellidos}`,
    tipoUsuario: dataUsuario.usu_tipo_usuario,
    isDTC,
    isAgente,
  };
};

export default useUsuario;
